// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from 'E:/zkh/word/PC_word/A9_Umi_WDC/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelLowCode0 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/admin/lowCode.js';
import ModelSystem1 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/admin/system.js';
import ModelOrganizational2 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/admin/system/organizational.js';
import ModelPosition3 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/admin/system/position.js';
import ModelProcess4 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/admin/system/process.js';
import ModelIndex5 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/attendance/index.js';
import ModelIndex6 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/contract/list/index.js';
import ModelIndex7 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/customer/list/index.js';
import ModelIndex8 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/dataAnalyse/index.js';
import ModelIndex9 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/employee/index.js';
import ModelIndex10 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/etlmodel/index.js';
import ModelHome11 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/home.js';
import ModelIndex12 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/performance/index.js';
import ModelIndex13 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/project/index.js';
import ModelTagManage14 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/project/tagManage.js';
import ModelUser15 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/user.js';
import ModelIndex16 from 'E:/zkh/word/PC_word/A9_Umi_WDC/src/models/usercenter/index.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'lowCode', ...ModelLowCode0 });
app.model({ namespace: 'system', ...ModelSystem1 });
app.model({ namespace: 'organizational', ...ModelOrganizational2 });
app.model({ namespace: 'position', ...ModelPosition3 });
app.model({ namespace: 'process', ...ModelProcess4 });
app.model({ namespace: 'index', ...ModelIndex5 });
app.model({ namespace: 'index', ...ModelIndex6 });
app.model({ namespace: 'index', ...ModelIndex7 });
app.model({ namespace: 'index', ...ModelIndex8 });
app.model({ namespace: 'index', ...ModelIndex9 });
app.model({ namespace: 'index', ...ModelIndex10 });
app.model({ namespace: 'home', ...ModelHome11 });
app.model({ namespace: 'index', ...ModelIndex12 });
app.model({ namespace: 'index', ...ModelIndex13 });
app.model({ namespace: 'tagManage', ...ModelTagManage14 });
app.model({ namespace: 'user', ...ModelUser15 });
app.model({ namespace: 'index', ...ModelIndex16 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
